import { Box, Container } from "@mantine/core";
import {
  AuthAppShellSkeleton,
  DiscoverBodySkeleton,
  DiscoverCompanyCardsShimmer,
  DiscoverTopNavSkeleton,
} from "@/pages/discover/components/DiscoverPageSkeleton";
import { DISCOVER_PAGE_CONTENT_PX } from "@/pages/discover/DiscoverPage.constants";

export { DiscoverBodySkeleton, AuthAppShellSkeleton } from "@/pages/discover/components/DiscoverPageSkeleton";

/**
 * Content-area fallback while a lazy child route loads inside AppShell.
 * Sidebar + header are already mounted — only shimmer the results grid.
 */
export function AppShellRouteFallback() {
  return (
    <Container fluid px={DISCOVER_PAGE_CONTENT_PX} py="md">
      <Box style={{ containerType: "inline-size" }}>
        <DiscoverCompanyCardsShimmer />
      </Box>
    </Container>
  );
}

/**
 * Auth session / user hydration gate — matches AppLayout chrome (sidebar + header).
 */
export function AuthRouteFallback() {
  return <AuthAppShellSkeleton />;
}

/**
 * Guest Suspense fallback: landing navbar + Discover body.
 */
export function RouteFallback() {
  return (
    <Box style={{ minHeight: "100vh", background: "#ffffff" }}>
      <DiscoverTopNavSkeleton />
      <DiscoverBodySkeleton />
    </Box>
  );
}
